import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';

const TEST_KEY = '__local_storage_test__';

function LocalStorageFacade() {
	function isSupported() {
		try {
			AtlBrowserStorageLocal.setItem(TEST_KEY, TEST_KEY);
			AtlBrowserStorageLocal.removeItem(TEST_KEY);
			return true;
		} catch (e) {
			return false;
		}
	}

	function setItem(key: string, value: string) {
		if (!isSupported()) {
			return;
		}

		AtlBrowserStorageLocal.setItem(key, value);
	}

	function getItem<T extends string>(key: string): T | null {
		if (!isSupported()) {
			return null;
		}
		return AtlBrowserStorageLocal.getItem(key) as T;
	}

	function removeItem(key: string) {
		if (!isSupported()) {
			return null;
		}
		return AtlBrowserStorageLocal.removeItem(key);
	}

	return {
		isSupported,
		getItem,
		setItem,
		removeItem,
	};
}

export default LocalStorageFacade();
